import React from 'react';

const MwTextArea = ({
    id,
    value,
    onChange,
    label,
    placeholder,
    rows,
    classNamePrivate,
    disabled = false,
    readOnly = false,
}) => {
    return (
        <>
            {label && (
                <label className="text-xs  font-normal px-1 mb-1 text-[#261759]" htmlFor={id}>
                    {label}
                </label>
            )}
            <textarea
                className={`text-xs font-normal text-[#261759] w-full rounded-md border outline-none  border-[#8D82B6]/50 p-2 ${classNamePrivate || ''}`}
                id={id}
                name={id}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                rows={rows}
                disabled={disabled}
                readOnly={readOnly}
                style={{ resize: 'none' }}
            />
        </>
    );
};

export default MwTextArea;
